'use client';

import { useEffect } from 'react';
import { ErrorFallback } from '@/components/ui/error-boundary';

/** Next.js App Router segment error UI — Report deep-links into Feedback Hub. */
export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('app/error.tsx', error);
  }, [error]);

  return <ErrorFallback error={error} resetError={reset} />;
}
